module.exports = __webpack_public_path__ + "static/media/oblique.1458e192.jpg";